export interface ConfigField {
  key: string;
  label: string;
  apiEndpoint: string;
  variant?: "recipients";
}

export interface ConfigSection {
  key: string;
  label: string;
  fields: ConfigField[];
}

export const CONFIG_SECTIONS: ConfigSection[] = [
  {
    key: "reimbursement",
    label: "Reimbursement",
    fields: [
      { key: "reimbursementType", label: "Reimbursement Type", apiEndpoint: "api/reimbursement-types" },
    ],
  },
  // {
  //   key: "inventory",
  //   label: "Inventory",
  //   fields: [
  //     { key: "inventoryType", label: "Inventory Type", apiEndpoint: "api/inventory-types" },
  //     { key: "inventoryStatus", label: "Inventory Status", apiEndpoint: "api/inventory-statuses" },
  //   ],
  // },
  {
    key: "leave",
    label: "Leave Recipient",
    fields: [
      { key: "leaveRecipient", label: "Leave Recipient", apiEndpoint: "api/leave-mail-cc-config", variant: "recipients" },
    ],
  },
  // Leave Policy — rich manager UI (no generic name-list fields). Rendered
  // specially in AdminConfig's index, like the Liri Admin section.
  {
    key: "leavePolicy",
    label: "Leave Policy",
    fields: [],
  },
  // {
  //   key: "employee",
  //   label: "Employee",
  //   fields: [
  //     { key: "employmentType", label: "Employment Type", apiEndpoint: "api/employment-types" },
  //     { key: "department", label: "Department", apiEndpoint: "api/departments" },
  //   ],
  // },
  // NEW: Liri Admin section
  {
    key: "liriadmin",
    label: "Liri Admin",
    fields: [],
  },
];